import {
    Component, Input, OnChanges, ViewContainerRef, ChangeDetectionStrategy, EventEmitter,
    Output, SimpleChanges
} from '@angular/core';
import {
    trigger,
    style,
    animate,
    transition
} from '@angular/animations';
// import { TooltipService } from '@swimlane/ngx-charts';

@Component({
    // providers: [TooltipService],
    selector: 'ngx-charts-chart-custom',
    template: `
      <div
        class="ngx-charts-outer"
        [style.width.px]="view[0]"
        [@animationState]="'active'"
        [@.disabled]="!animations">
        <svg
          class="ngx-charts"
          [attr.width]="chartWidth"
          [attr.height]="view[1]">
          <ng-content></ng-content>
        </svg>
        <ngx-charts-scale-legend
          *ngIf="showLegend && legendType === 'scaleLegend'"
          class="chart-legend"
          [valueRange]="legendOptions.domain"
          [colors]="legendOptions.colors"
          [height]="view[1]"
          [width]="legendWidth">
        </ngx-charts-scale-legend>
        <ngx-charts-legend
          *ngIf="showLegend && legendType === 'legend'"
          class="chart-legend"
          [data]="legendOptions.domain"
          [title]="legendOptions.title"
          [colors]="legendOptions.colors"
          [height]="view[1]"
          [width]="legendWidth"
          [activeEntries]="activeEntries"
          (labelClick)="legendLabelClick.emit($event)"
          (labelActivate)="legendLabelActivate.emit($event)"
          (labelDeactivate)="legendLabelDeactivate.emit($event)">
        </ngx-charts-legend>
      </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('animationState', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('500ms 100ms', style({ opacity: 1 }))
            ])
        ])
    ]
})
export class ChartComponent implements OnChanges {

    @Input() view;
    @Input() showLegend = false;
    @Input() legendOptions: any;

    // remove
    @Input() data;
    @Input() legendData;
    @Input() legendType: any;
    @Input() colors: any;
    @Input() activeEntries: any[];
    @Input() animations: boolean = true;

    @Output() legendLabelClick: EventEmitter<any> = new EventEmitter();
    @Output() legendLabelActivate: EventEmitter<any> = new EventEmitter();
    @Output() legendLabelDeactivate: EventEmitter<any> = new EventEmitter();

    chartWidth: any;
    title: any;
    legendWidth: any;

    constructor(
        private vcr: ViewContainerRef,
        // private tooltipService: TooltipService
        ) {
        // this.tooltipService.injectionService.setRootViewContainer(this.vcr);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.update();
    }

    update(): void {
        const legendColumns = 0;
        this.legendType = this.getLegendType();
        // console.log("this.showLegend", this.showLegend, this.legendType)
        /* if (this.showLegend) {
            this.legendType = this.getLegendType();

            if (this.legendType === 'scaleLegend') {
                legendColumns = 1;
            } else {
                legendColumns = 2;
            }
        } */

        const chartColumns = 12 - legendColumns;
// console.log("this.chartWidth", this.chartWidth, this.legendWidth)
        this.chartWidth = ~~(this.view[0] * chartColumns / 12.0);
        this.legendWidth = ~~(this.view[0] * 1 / 12.0);
    }

    getLegendType(): string {
        if (this.legendOptions.scaleType === 'linear') {
            return 'scaleLegend';
        } else {
            return 'legend';
        }
    }

}
